import {requestsCuttingStatuses} from "../RequestsCuttingState";

export const RequestsCuttingFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
    },
    {
        "idFromColumnFilter": "nominalQuantity",
        "id": "nominalQuantity",
    },
    {
        "idFromColumnFilter": "materialName",
        "id": "materialName",
    },
    {
        "idFromColumnFilter": "optimization",
        "id": "optimizationDisplay",
    },
    {
        "idFromColumnFilter": "thickness",
        "id": "thickness",
    },
    {
        "idFromColumnFilter": "note",
        "id": "note",
    },
    {
        "idFromColumnFilter": "materialOrganizationOption",
        "id": "materialOrganizationOptionName",
    },
    {
        "idFromColumnFilter": "order",
        "id": "orderNumber",
    },
    {
        "idFromColumnFilter": "workingCuttingMap",
        "id": "workingCuttingMapDisplay",
    },
    {
        "idFromColumnFilter": "plan",
        "id": "planName",
    },
    {
        "idFromColumnFilter": "date",
        "id": "date",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "requestsCuttingState",
        "id": "requestsCuttingState",
        "filterFn": (value, filterValue) => requestsCuttingStatuses[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]
